import { render, staticRenderFns } from "./ItemIndex.vue?vue&type=template&id=6b428488"
import script from "./ItemIndex.vue?vue&type=script&lang=js"
export * from "./ItemIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports